import {
  StorageExclusionItemType,
  StorageProtectionExclusionItem,
  StorageProtectionExclusionItemFormValue,
} from '@nirvana/shared/dtos/types/policies/common';
import { v4 as uuidv4 } from 'uuid';

// sanitize hash - remove all whitespaces and convert to lowercase
export function sanitizeHash(hash: string) {
  return hash.replace(/\s+/g, '').toLowerCase();
}

// sanitize wildcard - remove only whitespaces from the beginning and the end of the string
export function sanitizeWildcard(wildcard: string) {
  return wildcard.trim();
}

// sanitize path based on the type
export function sanitizePathByType(type: StorageExclusionItemType, path: string) {
  return type === StorageExclusionItemType.HASH ? sanitizeHash(path) : sanitizeWildcard(path);
}

// sanitize exclusion item form value to exclusion item
export function sanitizeExclusionItemFormValue(
  exclusionItem: StorageProtectionExclusionItemFormValue
): StorageProtectionExclusionItemFormValue {
  return {
    type: exclusionItem.type,
    path: sanitizePathByType(exclusionItem.type, exclusionItem.path),
    description: exclusionItem.description,
  };
}

// convert exclusion item form value to exclusion item (add id)
export function convertExclusionItemFormValue(
  exclusionItem: StorageProtectionExclusionItemFormValue
): StorageProtectionExclusionItem {
  return {
    idRelative: uuidv4(),
    ...exclusionItem,
  };
}

// sanitize exclusion item to exclusion item (sanitize path)
export function sanitizeExclusionItem(exclusionItem: StorageProtectionExclusionItem): StorageProtectionExclusionItem {
  return {
    idRelative: exclusionItem.idRelative,
    type: exclusionItem.type,
    path: sanitizePathByType(exclusionItem.type, exclusionItem.path),
    description: exclusionItem.description,
  };
}
